import React from 'react';
import { Box, Typography, Button } from '@material-ui/core';
import { Link as RouterLink } from 'react-router-dom';
import EmptyStateExchangeIcon from '../../../../../common/emptyStateIcons/emptyStateExchange.svg';
import useStyles from './styles';
import { POINTS_ROUTE } from '../../../../../../constants/Routes';

const EmptyState = () => {
  const classes = useStyles();
  return (
    <Box
      className={classes.container}
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      padding="64px"
    >
      <img src={EmptyStateExchangeIcon} />
      <Typography variant="h4" className={classes.text}>
        Aún no has realizado canjes con tus Ripley Puntos Go
      </Typography>
      <Button
        className={classes.button}
        variant="contained"
        color="primary"
        component={RouterLink}
        to={{
          pathname: POINTS_ROUTE,
        }}
      >
        Canjear Ripley Puntos Go
      </Button>
    </Box>
  );
};

export default EmptyState;
